import React from "react";
import { Typography } from "@mui/material";
import Modal from "../../../components/Modal/Modal";
import { AppButton } from "../../../components/UI";

export default function ConfirmDialog({ open, onClose, onConfirm, text, loading }) {
    return (
        <Modal
            open={open}
            onClose={loading ? undefined : onClose}
            title="Confirmer le mouvement"
            maxWidth="xs"
            actions={(
                <>
                    <AppButton variant="secondary" onClick={onClose} disabled={loading}>Annuler</AppButton>
                    <AppButton variant="primary" onClick={onConfirm} loading={loading}>Confirmer</AppButton>
                </>
            )}
        >
            <Typography sx={{ fontSize: "0.92rem", color: "#334155" }}>{text}</Typography>
        </Modal>
    );
}
